<template>
    <div class="Deduction">
        <div class="border-bottom margin-top1" style="overflow: hidden;">
            <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="80px">
                <el-form-item label="采购类型" prop="Bill">
                    <el-select v-model="ruleForm.purchaseFrom" placeholder="请选择">
                        <el-option
                            v-for="item in BillList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始日期" prop="startString">
                    <el-date-picker
                        v-model="ruleForm.startString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="endString">
                    <el-date-picker
                        v-model="ruleForm.endString"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label prop="searchString" style="width: 40%;">
                    <el-input
                        v-model="ruleForm.searchString"
                        placeholder="采购单据号、订单号、库存编号"
                        style="width: 70%;"
                    ></el-input>
                    <el-button
                        type="primary"
                        style="margin-left: 5px;"
                        class="search"
                        @click="getAllPurchaseListByCId2()"
                    >搜索</el-button>
                    <el-button type="primary" class="search" @click="searchReset('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row class="padding">
            <el-col :span="6">采购总费用：{{this.totalPrice}}</el-col>
        </el-row>
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column align="center" prop="purchaseNumber" label="采购单据号"></el-table-column>
            <el-table-column align="center" prop="purchaseFromString" label="单据类型"></el-table-column>
            <el-table-column align="center" label="订单号/库存编号 ">
                <template slot-scope="scope">
                   <div v-if="scope.row.purchaseFrom == 1">{{scope.row.orderId}}</div>
                   <div v-if="scope.row.purchaseFrom == 2">{{scope.row.inventoryNo}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="purchasePrice" label="采购价"></el-table-column>
            <el-table-column align="center" prop="rebatePrice" label="返佣"></el-table-column>
            <el-table-column align="center" prop="otherPrice" label="其他费用"></el-table-column>
            <el-table-column align="center" prop="createTime" label="采购时间"></el-table-column>
            <el-table-column align="center" label="总计">
                <template slot-scope="scope">
                    <p>{{scope.row.purchaseTotalAmount}}</p>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
        <el-pagination
            style="margin-top: 16px; text-align:center;"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page="currentPage"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        ></el-pagination>
        </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    name: "Procurement_fee",
    props: ['dateData'],
    data() {
        return {
            totalPrice: "",
            pagesize: 10,
            currentPage: 1,
            pages: 1,
            total: 50,
            tableData: [],
            BillList: [
                {
                    value: "0",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "订单采购"
                },
                {
                    value: "2",
                    label: "库存采购"
                },
                {
                    value: "3",
                    label: "其他采购"
                }
            ],
            ruleForm: {
                purchaseFrom: null,
                startString: "", //开始时间
                endString: "", //结束时间
                searchString: ""
            }
        };
    },
    mounted() {
        this.init();
    },
    created() {
        this.getAllPurchaseListByCId();
    },
  watch: {
    dateData: {
      handler(newVal) {
        if (newVal) {
          this.ruleForm.startString = newVal.startTime
          this.ruleForm.endString = newVal.endTime
          // this.search();
        }
      },
      immediate: true
    }
  },
    methods: {
        getAllPurchaseListByCId2(){
            this.currentPage = 1
            this.getAllPurchaseListByCId()
        },
        getAllPurchaseListByCId() {
            var role = JSON.parse(window.localStorage.getItem("role"));
            var parameter = {
                page: this.currentPage,
                size: this.pagesize,
                companyId: role.company_id,
                startTimeString: this.ruleForm.startString,
                endTimeString: this.ruleForm.endString,
                searchString: this.ruleForm.searchString,
                purchaseFrom: this.ruleForm.purchaseFrom
            };
            ajaxPost(
                Baseurl + "purchaseController/getAllPurchaseListByCId",
                parameter
            ).then(res => {
                (this.tableData = res.data.data.pageInfo.list),
                (this.totalPrice = res.data.data.totalPrice),
                (this.pagesize = res.data.data.pageInfo.pageSize),
                (this.currentPage = res.data.data.pageInfo.pageNum),
                (this.total = res.data.data.pageInfo.total),
                (this.pages = res.data.data.pageInfo.pages);
            });
        },
        init() {},
        // startTime1() {
        //     var d = new Date();
        //     var datetime =
        //         d.getFullYear() +
        //         "-" +
        //         (d.getMonth() + 1) +
        //         "-" +
        //         d.getDate() +
        //         " 00:00:00";
        //     this.ruleForm.startString = datetime;
        // },
        // endTime1() {
        //     var d = new Date();
        //     var datetime =
        //         d.getFullYear() +
        //         "-" +
        //         (d.getMonth() + 1) +
        //         "-" +
        //         d.getDate() +
        //         " 23:59:59";
        //     this.ruleForm.endString = datetime;
        // },
        searchReset(formName) {
            this.ruleForm.purchaseFrom = null;
            this.$refs[formName].resetFields();
            this.getAllPurchaseListByCId();
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.getAllPurchaseListByCId();
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getAllPurchaseListByCId();
            console.log(`当前页: ${val}`);
        }
    }
};
</script>

<style lang="scss" scoped>
.Deduction {
    width: 98%;
    overflow: hidden;
    .Deduction-content {
        .el-form-item {
            overflow: hidden;
            width: 20%;
            margin-bottom: 18px;
            float: left;
        }
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
    }
}
.page{
    position: fixed;
    width: 86%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    line-height: 50px;
}
.padding {
    padding: 25px 0;
}
</style>
